/**
 * @generated SignedSource<<712beb9772e710d1648651a7ece77bfa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type HelpObjectStoreSearchBackend = "JIRA" | "SEARCH_PLATFORM" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type portalsFragment$data = {
  readonly portals: ReadonlyArray<{
    readonly __typename: "HelpObjectStoreSearchResult";
    readonly id?: string;
    readonly isExternal?: boolean;
    readonly message?: string | null | undefined;
    readonly searchBackend?: HelpObjectStoreSearchBackend | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"portalItemFragment">;
  } | null | undefined>;
  readonly " $fragmentType": "portalsFragment";
};
export type portalsFragment$key = {
  readonly " $data"?: portalsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"portalsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "helpCenterAri"
    },
    {
      "kind": "RootArgument",
      "name": "portalIds"
    },
    {
      "kind": "RootArgument",
      "name": "queryTerm"
    },
    {
      "kind": "RootArgument",
      "name": "resultLimit"
    }
  ],
  "kind": "Fragment",
  "name": "portalsFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "portals",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Literal",
                "name": "entityType",
                "value": "PORTAL"
              },
              {
                "kind": "Variable",
                "name": "helpCenterAri",
                "variableName": "helpCenterAri"
              },
              {
                "kind": "Variable",
                "name": "portalIds",
                "variableName": "portalIds"
              },
              {
                "kind": "Variable",
                "name": "queryTerm",
                "variableName": "queryTerm"
              },
              {
                "kind": "Variable",
                "name": "resultLimit",
                "variableName": "resultLimit"
              }
            ],
            "kind": "ObjectValue",
            "name": "searchInput"
          }
        ],
        "kind": "LinkedField",
        "name": "searchHelpObjects",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "kind": "ScalarField",
                  "name": "__typename"
                },
                "action": "THROW",
                "path": "portals.__typename"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "kind": "ScalarField",
                  "name": "id"
                },
                "action": "THROW",
                "path": "portals.id"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "kind": "ScalarField",
                  "name": "isExternal"
                },
                "action": "THROW",
                "path": "portals.isExternal"
              },
              {
                "kind": "ScalarField",
                "name": "searchBackend"
              },
              {
                "kind": "FragmentSpread",
                "name": "portalItemFragment"
              }
            ],
            "type": "HelpObjectStoreSearchResult"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ],
            "type": "HelpObjectStoreQueryError"
          }
        ]
      },
      "action": "THROW",
      "path": "portals"
    }
  ],
  "type": "HelpObjectStoreQueryApi"
};

(node as any).hash = "6df6301d2505c868184d8976da29ebbc";

export default node;
